// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BWo4Q","verticalAlign":"styles_verticalAlign__imDG1"};